export enum RegisterNewUserResponseStates {
    ADDED = "ADDED",
    EXISTING = "EXISTING"
}
